import { render } from "./pca-select-box-local-data.vue?vue&type=template&id=719b112c"
import script from "./pca-select-box-local-data.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-select-box-local-data.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-select-box-local-data.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "719b112c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('719b112c', __exports__)) {
    api.reload('719b112c', __exports__)
  }
  
  module.hot.accept("./pca-select-box-local-data.vue?vue&type=template&id=719b112c", () => {
    api.rerender('719b112c', render)
  })

}


export default __exports__